export const Regex = {
  BASE_RATE: /^10000$|^[0-9]{1,4}$|^([1-9][0-9]{0,3})$/,
  DIGIT: /^[0-9]*$/,
  EMAIL: /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i,
  PHONE: /^(05[0-9])-([0-9]{3})-([0-9]{4})$/,
  MAN_HOURS: /^(0([.,]\d{0,8})?|[1-9](\d?)([.,]\d{0,8})?)$/,
  RATE: /^(0(\.[1-9])?|1)$/,
  RATE_INPUT: /^(0|0[.,][1-9]?|1)$/,
};
